import type { ComponentFeatureFlipperNOTObject, ComponentFeatureFlippers } from "../types";

/**
 * This method is used to determine if a feature flipper is an object with a NOT property.
 *
 * @param feature The feature flipper to check
 * @returns boolean indicating if the feature flipper is an object with a NOT property
 */
export const isFeatureNOTObject = (
  feature: ComponentFeatureFlippers
): feature is ComponentFeatureFlipperNOTObject => {
  return !!feature && typeof feature === "object" && "NOT" in feature;
};
